module.exports = __webpack_public_path__ + "static/media/the-nightly-app-download.b45e495f.png";